export function foldFatLabel(s) {
  return String(s || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
}

export function matchProjFatTpl(rec, tpls) {
  const list = (Array.isArray(tpls) ? tpls : [])
    .filter((t) => Number(t?.projFatTpl_ativo) !== 0)
    .sort((a, b) => Number(a?.projFatTpl_ord || 0) - Number(b?.projFatTpl_ord || 0))
  if (!list.length) return null
  const recId = Number(rec?.projFatTpl_id) || 0
  if (recId > 0) {
    const hit = list.find((t) => Number(t.projFatTpl_id) === recId)
    if (hit) return hit
  }
  const mun = Number(rec?.mun_id) || 0
  if (mun > 0) {
    const byMun = list.filter((t) => Number(t.mun_id) === mun)
    if (byMun.length === 1) return byMun[0]
    if (byMun.length > 1) {
      const ep = foldFatLabel(rec?.rec_ep)
      let best = null
      let bestLen = 0
      byMun.forEach((t) => {
        const p = foldFatLabel(t.projFatTpl_epPrefix || t.projFatTpl_nome)
        if (p && ep.includes(p) && p.length >= bestLen) {
          best = t
          bestLen = p.length
        }
      })
      if (best) return best
    }
  }
  const ep = foldFatLabel(rec?.rec_ep)
  let best = null
  let bestLen = 0
  list.forEach((t) => {
    const p = foldFatLabel(t.projFatTpl_epPrefix || t.projFatTpl_nome)
    if (!p || !ep) return
    if (ep.includes(p) && p.length >= bestLen) {
      best = t
      bestLen = p.length
    }
  })
  if (best) return best
  if (list.length === 1) return list[0]
  return list.find((t) => Number(t.projFatTpl_padrao) === 1) || null
}

